// 供货明细表
export default {
  // 第一次导入
  FIRST_IMPORT: '/warehouse/shippingInstruction/ck/firstImportExcel',
  // 分页接口
  QUERY_TABLEDATA: '/warehouse/deliverydetailsimportlog/page',
  // 出库冲销
  WRITEOFFALL_CHUKU: '/warehouse/storageLade/ck/writeOffAll',
  // 导出
  EXPORT: '/warehouse/deliverydetailsimportlog/export',
  // 重新导入
  NEW_IMPORT: '/warehouse/shippingInstruction/ck/anewImportExcel',
  // 日志导出
  EXPORT_LOG: '/warehouse/deliverydetailsimportlog/export',
  // 入库冲销
  WRITE_OFF: '/warehouse/shippingInstruction/ck/writeOffCk',
  // 出库第一次导入
  FIRST_IMPORT_CHUKU: '/warehouse/storageLade/ck/importExcel',
  // 入库 重新入库
  NEW_STORAGE: '/warehouse/shippingInstruction/ck/restorage',
  // 出库重新导入
  NEW_IMPORT_CHUKU: '/warehouse/storageLade/ck/anewImportExcel',
  // 重新出库
  NEW_STORAGE_CHUKU: '/warehouse/storageLade/ck/reOutbound',
  // 文件描述编辑
  EDIT_FILE_DESCRIBE: '/warehouse/deliverydetailsimportlog/updateFileDescriptionByid',
  // 发送金蝶
  SEND_JINDIE: '/warehouse/shippingInstruction/ck/sendEasJinDie',
  // 出库-发送金蝶
  SEND_JINDIE_EXPORT: '/warehouse/storageLade/ck/pushJindie',
};
